import { render } from "./UniversalForm.vue?vue&type=template&id=fba6d6aa&scoped=true"
import script from "./UniversalForm.vue?vue&type=script&lang=js"
export * from "./UniversalForm.vue?vue&type=script&lang=js"

import "./UniversalForm.vue?vue&type=style&index=0&id=fba6d6aa&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fba6d6aa"]])

export default __exports__